<template>
    <div class="container">
        <div class="search" style="display:flex">
            <el-form ref="formRef" style="flex:1" :inline="true" :model="form" class="demo-form-inline" size="mini">
                <el-form-item label="商户CODE：" prop="partner_code">
                    <el-input v-model.trim="form.partner_code" placeholder=" " @keyup.enter="onSearch"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" style="margin-left: 16px;" class="btnClass"
                        @click="onSearch">搜索</el-button>
                    <el-button type="text" class="textBtn" style="padding-bottom: 0px;vertical-align: bottom;"
                        @click="resetForm(formRef)">重置</el-button>
                </el-form-item>
            </el-form>
        </div>
        <el-table :data="list" size="mini">
            <!-- 币种明细：一个商户一行，多币种在此展开查看，各行金额按自身币种展示 -->
            <el-table-column type="expand">
                <template v-slot="scope">
                    <div class="currency-detail">
                        <el-table v-if="scope.row.currencies && scope.row.currencies.length"
                            :data="scope.row.currencies" size="mini" border>
                            <el-table-column label="币种" width="100">
                                <template v-slot="currencyItem">
                                    <span>{{ currencyItem.row.currency }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column label="可提现金额">
                                <template v-slot="currencyItem">
                                    <span>{{ formatAmount(currencyItem.row.amount_cny, currencyItem.row.currency) }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column label="待结算金额">
                                <template v-slot="currencyItem">
                                    <span>{{ formatAmount(currencyItem.row.unsettled_amount_cny, currencyItem.row.currency) }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column label="提取中的金额">
                                <template v-slot="currencyItem">
                                    <span>{{ formatAmount(currencyItem.row.frozen_amount_cny, currencyItem.row.currency) }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column label="已经提取的金额(累计)">
                                <template v-slot="currencyItem">
                                    <span>{{ formatAmount(currencyItem.row.withdrawn_amount_cny, currencyItem.row.currency) }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column label="相机生产补贴金额(累计)" width="180">
                                <template v-slot="currencyItem">
                                    <span>{{ formatAmount(currencyItem.row.device_factory_amount_cny, currencyItem.row.currency) }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column label="相机激活补贴金额(累计)" width="180">
                                <template v-slot="currencyItem">
                                    <span>{{ formatAmount(currencyItem.row.device_activation_amount_cny, currencyItem.row.currency) }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column label="云存收入佣金(累计)">
                                <template v-slot="currencyItem">
                                    <span>{{ formatAmount(currencyItem.row.order_commission_cny, currencyItem.row.currency) }}</span>
                                </template>
                            </el-table-column>
                        </el-table>
                        <span v-else class="currency-empty">该商户暂无币种账户明细</span>
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="商户CODE">
                <template v-slot="scope">
                    <span>{{ scope.row.partner_code }}</span>
                </template>
            </el-table-column>
            <el-table-column label="企业名称">
                <template v-slot="scope">
                    <span>{{ scope.row.partner_name }}</span>
                </template>
            </el-table-column>
            <!-- 以下平铺金额均为商户主币种金额，符号取 scope.row.currency；主币种无账户行时为 0（正常） -->
            <el-table-column label="可提现金额">
                <template v-slot="scope">
                    <span>{{ formatAmount(scope.row.amount_cny, scope.row.currency) }}</span>
                </template>
            </el-table-column>
            <el-table-column label="相机激活补贴金额(累计)" width="180">
                <template v-slot="scope">
                    <span>{{ formatAmount(scope.row.device_activation_amount_cny, scope.row.currency) }}</span>
                </template>
            </el-table-column>
            <el-table-column label="相机生产补贴金额(累计)" width="180">
                <template v-slot="scope">
                    <span>{{ formatAmount(scope.row.device_factory_amount_cny, scope.row.currency) }}</span>
                </template>
            </el-table-column>
            <el-table-column label="提取中的金额">
                <template v-slot="scope">
                    <span>{{ formatAmount(scope.row.frozen_amount_cny, scope.row.currency) }}</span>
                </template>
            </el-table-column>
            <el-table-column label="云存收入佣金(累计)">
                <template v-slot="scope">
                    <span>{{ formatAmount(scope.row.order_commission_cny, scope.row.currency) }}</span>
                </template>
            </el-table-column>
            <el-table-column label="待结算金额">
                <template v-slot="scope">
                    <span>{{ formatAmount(scope.row.unsettled_amount_cny, scope.row.currency) }}</span>
                </template>
            </el-table-column>
            <el-table-column label="已经提取的金额(累计)">
                <template v-slot="scope">
                    <span>{{ formatAmount(scope.row.withdrawn_amount_cny, scope.row.currency) }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="currency" label="主币种" />
            <el-table-column label="操作">
                <template v-slot="scope">
                    <router-link :to="`/salespartner/fundsaccount/detail/${scope.row.partner_code}`">
                        <el-button type="primary" size="mini" class="btnClass">详情</el-button>
                    </router-link>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination @current-change="handleCurrentChange" v-model:currentPage="pagination.page"
            :page-size="pagination.limit" layout="total, prev, pager, next" :total="pagination.total" background>
        </el-pagination>
    </div>
</template>

<script>
import { onMounted, reactive, ref, toRaw } from 'vue'
import { ElMessage } from 'element-plus'
import { useRouter } from 'vue-router'
import util from '../../../util/util'
import api from '../../../axios/api'
import { formatAmount } from '../../../util/salesPartner'

export default {
    setup() {
        const router = useRouter()
        const form = reactive({
            partner_code: ''
        })
        const pagination = reactive({
            page: 1,
            limit: 16,
            total: 0
        })
        const formRef = ref()
        const list = ref([])

        const handleCurrentChange = (val) => {
            pagination.page = val
            onSearch()
        }

        const onSearch = async () => {
            const res = await api.SalesPartnerFundsAccountList({
                ...toRaw(form),
                page: pagination.page,
                limit: pagination.limit
            })
            if (res.data.code === 200) {
                const { data, page_info } = res.data.data
                list.value = data
                pagination.total = page_info.total
            } else {
                ElMessage.error('查询失败: ' + res.msg)
            }
        }

        const add = () => {
            router.push('/salespartner/list/add/0')
        }

        const resetForm = (formEl) => {
            if (!formEl) return
            formEl.resetFields()
            onSearch()
        }

        onMounted(() => {
            onSearch()
        })

        return {
            form,
            onSearch,
            list,
            formRef,
            pagination,
            handleCurrentChange,
            add,
            resetForm,
            util,
            formatAmount
        }
    }
}
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
.container {
	font-family: 'Manrope';
	font-style: normal;
	font-weight: 400;
	font-size: 14px;
	.search {
		background: #F0F2F5;
		padding-top: 16px;
		margin-bottom: 24px;
	}
	.el-form {
		::v-deep(.el-form-item__label) {
			font-family: 'Manrope';
			font-style: normal;
			font-weight: 400;
			font-size: 14px;
			color: #000000;
            opacity: 0.8;
			padding-right: 0px;
		}
		.el-form-item {
			margin-left: 24px;
		}
	}
	.btnClass {
		color: #FFF;
		background-color: #FB6D07;
		border-color: #FB6D07;
	}
	.textBtn {
		color: #FB6D07;
	}
	.currency-detail {
		padding: 8px 16px;
	}
	.currency-empty {
		font-size: 12px;
		color: #909399;
	}
	::v-deep(thead) {
		font-family: 'Manrope';
		font-style: normal;
		font-weight: 400;
		font-size: 14px;
		color: #000;
		opacity: 0.8;
		th {
			font-weight: 400;
			background-color: #F0F2F5;
		}
	}
  ::v-deep(tbody) {
    tr {
      font-family: 'Manrope';
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      color: #000000;
      opacity: 0.8;
    }
  }

}
</style>
